<template>
  <div class="dashboard-page-cont trade-classroom" v-if="newsList.length>0">
    <div style="display:flex;justify-content: space-between;">
      <span class="model-title">动态·视野</span>
    </div>
    <div v-for="item in newsList" :key="item.id" @click="turnUrl(item)" class="trade-classroom-first">
      <div class="trade-classroom-first-left">
        <img v-if="item.attachment" :src="`${previewstatic}?code=${item.attachment}`" alt="" />
        <p class="trade-classroom-first-desc">{{item.title}}</p>

        <!-- <el-popover
          placement="bottom"
          width="270"
          trigger="hover"
          :content="item.title">
          <p slot="reference" class="trade-classroom-first-desc">{{item.title}}</p>
        </el-popover> -->
      </div>
      <div><i class="el-icon-arrow-right" style="margin-top:3px"></i></div>
    </div>
   
    <!-- <ul class="trade-classroom-other">
      <li class="trade-classroom-other-item">
        <a class="trade-classroom-other-link" href="javascript:(void 0)">
          <span class="trade-classroom-other-label">如何选择最适合你的出口方式</span>
          <i class="el-icon-arrow-right trade-classroom-other-icon"></i>
        </a>
      </li>
      <li class="trade-classroom-other-item">
        <a class="trade-classroom-other-link" href="javascript:(void 0)">
          <span class="trade-classroom-other-label">一堂课带你了解进出口经营权办理流程</span>
          <i class="el-icon-arrow-right trade-classroom-other-icon"></i>
        </a>
      </li>
      <li class="trade-classroom-other-item">
        <a class="trade-classroom-other-link" href="javascript:(void 0)">
          <span class="trade-classroom-other-label">新年开工如何跟进海外采购</span>
          <i class="el-icon-arrow-right trade-classroom-other-icon"></i>
        </a>
      </li>
      <li class="trade-classroom-other-item">
        <a class="trade-classroom-other-link" href="javascript:(void 0)">
          <span class="trade-classroom-other-label">新年开工如何跟进海外采购</span>
          <i class="el-icon-arrow-right trade-classroom-other-icon"></i>
        </a>
      </li>
    </ul> -->
  </div>
</template>
<script>
import { getListByType,insertAdvertisingEffect,insertAdvertisingClick} from '@/utils/api/dashboard';
import { previewstatic } from '@/utils/config';
import {openWindow} from "@/utils/common";
export default {
  data(){
    return{
      previewstatic,
      newsList:[]
    }
  },
  methods:{
    getLastsNewList(){
      let params= {"advertisingType":34}
      getListByType(params)
      .then(res=>{
        if(res.rspResult.bizCode==200){
          this.newsList = res.rspListData.list;
          // 曝光量
          this.newsList.forEach((item, index) => {
              const params = {
                advertisingId: item.id,
                lengthStay: 0,
              };
              insertAdvertisingEffect(params);//曝光量
            });
        }
      })
      .catch((err)=>{
        this.$message.error("System error",err);
      })
    },
    // 点击量
    turnUrl(item){
      const params = {
        advertisingId: item.id,
      };
      insertAdvertisingClick(params).then((res) => {
        let adId2 = res ? window.btoa(res.data.id) : "";
        openWindow(item.imgLinkUrl, adId2);
      });
    }, 
  },
  mounted(){
    this.getLastsNewList()
  },
}
</script>

<style lang="scss" scoped>
.trade-classroom {
  background: #fff;
  padding: 20px 20px 14px;
  box-shadow: 0 1px 6px 0 #001e3b12;
  &-all {
    float: right;
    height: 14px;
    line-height: 14px;
    font-family: SourceHanSansCN-Regular;
    font-weight: 400;
    font-size: 12px;
    color: #066EB7;
    letter-spacing: 0;
  }
  &-first {
    display: flex;
    justify-content: space-between;
    margin-bottom: 14px;
    .trade-classroom-first-left{
      display: flex;
      img {
        width: 88px;
        height: 66px;
        margin-right: 12px;
        flex-shrink: 0;
      }
      .trade-classroom-first-desc {
          padding-right: 24px;
          // height: 46px;
          line-height: 23px;
          font-family: SourceHanSansCN-Regular;
          font-weight: 400;
          font-size: 14px;
          color: #16181A;
          letter-spacing: 0;
          // 第二行缩略
          display: -webkit-box;
          text-overflow: ellipsis;
          overflow: hidden;
          -webkit-box-orient: vertical;
          -webkit-line-clamp:3;
      }
    }
  }
  .trade-classroom-first:hover{
    cursor: pointer;
    color: #066EB7;
    .trade-classroom-first-desc{
      color: #066EB7;
    }
  }
  .trade-classroom-other-item {
    margin-bottom: 8px;
    &:nth-last-child(1) {
      margin-bottom: 0;
    }
  }
  .trade-classroom-other-link {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 26px;
    .trade-classroom-other-label {
      flex: 1;
      position: relative;
      top: 17px;
      // height: 26px;
      // line-height: 26px;
      font-family: SourceHanSansCN-Regular;
      font-weight: 400;
      font-size: 14px;
      color: #16181A;
      letter-spacing: 0;
      display: -webkit-box;
      text-overflow: ellipsis;
      overflow: hidden;
      -webkit-box-orient: vertical;
      -webkit-line-clamp:3;
    }
    .trade-classroom-other-icon {
      width: 14px;
      height: 14px;
      margin-left: 20px;
      flex-shrink: 0;
      font-size: 12px;
      text-align: center;
      font-weight: bold;
      color:#000333;
    }
  }

}
</style>